module.exports = __webpack_public_path__ + "static/media/Mary_R@3x.e2794a98.jpg";